<template>
  <h1 v-html="desmembrado">
  </h1>
</template>

<script>
export default {
  name: 'Letreiro',
  props: {
    title: String
  },
  computed: {
    desmembrado() {
      let newStr = '';
      for (var i = 0; i < this.title.length; i++) {
        newStr += '<span>' + this.title.charAt(i) + '</span>';
      }
      return newStr;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>
